import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { Product, SingleProduct } from '../interfaces/product.model';
import { tap } from 'rxjs/operators';
import { Store } from '../interfaces/store.model';

@Injectable({ providedIn: 'root' })
export class StateService {
    private product: Product;
    private store: Store;
    constructor() { }

    /** saves a product in cache to be passed to each page*/
    setProduct(product: Product | SingleProduct): void {
        this.product = product;
    }

    /** returns a product to be used within the page */
    getProduct(): Product {
        return this.product;
    }
    /** saves a store in cache to passed to each page*/
    setStore(store: Store): void {
        this.store = store;
    }
    /** returns a store t0 be used within the page */
    getStore(): Store {
        return this.store;
    }

    
}
